import { useEffect, useState } from 'react';
import addToFavoritesIcon from '../assets/добавить в избр.png';
import addedToFavoritesIcon from '../assets/добавленно в избр.png';

interface ProductCardProps {
  image: string;
  title: string;
  price: number;
  productId?: string;
  isFavorite?: boolean;
  onFavoriteToggle?: (productId: string, isFavorite: boolean) => void;
}

export default function ProductCard({
  image,
  title,
  price,
  productId,
  isFavorite: initialFavorite = false,
  onFavoriteToggle,
}: ProductCardProps) {
  const [localFavorite, setLocalFavorite] = useState(initialFavorite);
  const isFavorite = onFavoriteToggle ? initialFavorite : localFavorite;

  useEffect(() => {
    if (!onFavoriteToggle) {
      setLocalFavorite(initialFavorite);
    }
  }, [initialFavorite, onFavoriteToggle]);

  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (productId && onFavoriteToggle) {
      onFavoriteToggle(productId, !isFavorite);
      return;
    }

    setLocalFavorite((prev) => !prev);
  };

  const formatPrice = (value: number) => new Intl.NumberFormat('ru-RU').format(value);

  return (
    <div className="group relative w-full overflow-hidden rounded-[18px] bg-white transition-all duration-150 hover:shadow-xl sm:rounded-[20px]">
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-white">
        <img
          src={image}
          alt={title}
          className="h-full w-full object-contain bg-white p-[6px] transition-transform duration-200 group-hover:scale-[1.02] sm:p-[8px]"
        />

        <button
          type="button"
          onClick={handleFavoriteClick}
          className="absolute right-1 top-1 z-10 flex h-[34px] w-[34px] items-center justify-center transition-transform duration-100 hover:scale-110 active:scale-95 sm:right-2 sm:top-2 sm:h-[40px] sm:w-[40px]"
        >
          <img
            src={isFavorite ? addedToFavoritesIcon : addToFavoritesIcon}
            alt={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
            className="h-full w-full"
          />
        </button>
      </div>

      <div className="flex min-h-[96px] flex-col justify-between bg-white px-2.5 pb-2.5 pt-2 sm:min-h-[118px] sm:px-[12px] sm:pb-[14px] sm:pt-[10px]">
        <h3
          className="overflow-hidden text-[14px] font-normal leading-[18px] text-black sm:text-[20px] sm:leading-[24px]"
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {title}
        </h3>

        <div className="mt-3 flex justify-end">
          <span className="text-[20px] font-bold leading-none text-black sm:text-[26px]">
            {formatPrice(price)} ₽
          </span>
        </div>
      </div>
    </div>
  );
}
